import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {
    IAdminToolPanel, UpgradeHelper, AdminToolPanelHelper, JourneyImportAndExportHelper, AdminToolHelper
} from '../../../helpers';
import { Spinner, SpinnerType, Button, ButtonType, Label } from 'office-ui-fabric-react';
import types from '../../../store/types';
import { PanelHeader } from '../../admintool/panelheader';
import { SPINNER_LOADING_MESSAGE, PANEL_VALUE_ZIP_UPLOADED } from '../../../constants';
interface IProps {
    adminToolState: any;
    panelName: string;
    isDisplayed: boolean;
}
declare var jQuery;
export class ZipImport extends React.Component<IProps, any> {

    componentDidMount() {
        AdminToolPanelHelper.SetUpPanelState(this.props.adminToolState, this.props.panelName, this.props.isDisplayed);
    }

    onClickFileUploadButton(e: any) {
        let panel: IAdminToolPanel = AdminToolPanelHelper.GetPanel(this.props.adminToolState, this.props.panelName);
        AdminToolPanelHelper.ClearPanelErrorMessages(panel);
        AdminToolPanelHelper.SetPanelIsLoading(this.props.panelName,true);
        let form: any = jQuery('#zipfileuploadform')[0];
        let formData: any = new FormData(form);
        JourneyImportAndExportHelper.GetZipInfo(formData, this.props.panelName);
    }

    removeZipFile(e: any) {
        let zipUploaded: boolean = false;
        jQuery("#uploadzip").val('');
        AdminToolPanelHelper.AddOrUpdatePanelValue(this.props.panelName, "zipUploaded", zipUploaded);
        AdminToolHelper.ClearProcessList();
    }
    render() {
        let panel: IAdminToolPanel = AdminToolPanelHelper.GetPanel(this.props.adminToolState, this.props.panelName);
        let displayed:boolean = AdminToolPanelHelper.IsPanelDisplayed(panel);
        let errors: string[] = AdminToolPanelHelper.GetErrorMessagesFromState(panel);
        let isLoading = AdminToolPanelHelper.IsLoading(panel);
        let zipUploaded: boolean = (AdminToolPanelHelper.GetPanelValueFromState(panel, PANEL_VALUE_ZIP_UPLOADED) as boolean)
        var errorResults = errors.map((result: string, index: any) => {
            return <p>{result}</p>
        });

        let style: any = {};
        if (zipUploaded) {
            style = { "display": "none" }
        }
        return <div className="zipimport admintool-panelcontainer">
            <PanelHeader panelTitle={"Import Journeys by zip"} panelName={this.props.panelName} enableToggle={true} isEnabled={true} 
                adminToolState={this.props.adminToolState} />
            <div className="panel-content" style={!displayed ? { display: 'none' } : {}}>
                <Label>Upload a zip file:</Label>
                <form id="zipfileuploadform" name="fileupload">
                    {zipUploaded && <div role="alert" className="alert alert-info"> <i className="ms-Icon ms-Icon--Accept" aria-hidden="true"></i> The Zip folder is ready to be imported.</div>}
                    <input style={style} disabled={isLoading} accept={".zip"} id="uploadzip" type="file" name="zipfile" />
                    {!zipUploaded && <button className={"ms-Button ms-Button--primary"} onClick={(e: any) => this.onClickFileUploadButton(e)} type="button">Upload Zip</button>}
                    {zipUploaded && <button className={"ms-Button ms-Button--primary"} onClick={(e: any) => this.removeZipFile(e)} type="button">Remove Zip</button>}
                </form>
                <br />
                {errorResults.length > 0 && <div className="alert alert-danger" role="alert">
                    {errorResults}
                </div>}
                {isLoading && <Spinner className="loading-zipimport" type={SpinnerType.normal} label={SPINNER_LOADING_MESSAGE} />}
            </div>
        </div>
    }
}




// WEBPACK FOOTER //
// ./source/ts/components/admintool/panels/zipimport.tsx